import { FN_GRID2D__possible_features__guests } from '@/pages/_base/grid2d/_hooks/FN_GRID2D__possible_features__guests';
import { FN_GRID2D__possible_features__workspace_users } from '@/pages/_base/grid2d/_hooks/FN_GRID2D__possible_features__workspace_users';
import { DTO__entity_with_grid2d } from '@shared/dto/+workspace/workspace_entity/_database_entity_with_grid2d_permissions/DTO__entity_with_grid2d';
import { store } from '../../../state/store';

export function FN_GRID2D__init_possible_features(items: DTO__entity_with_grid2d[]) {
  let { user_id } = store.getState().slice_user;

  for (let item of items) {
    let workspace_user_id = get_workspace_user_id(item.workspace_id, user_id);

    item.grid2d_possible_features = workspace_user_id
      ? FN_GRID2D__possible_features__workspace_users(item.type)
      : FN_GRID2D__possible_features__guests(item.type);
  }
}

function get_workspace_user_id(workspace_id: string, user_id: string) {
  let out = '';

  let { all_workspaces_users_map } = store.getState().slice_workspace;

  let workspace_users_map = all_workspaces_users_map.get(workspace_id);

  if (!workspace_users_map) return out;

  let workspace_user = workspace_users_map.get(user_id);

  if (!workspace_user) return out;

  out = workspace_user._id;

  return out;
}
